import { render } from "./TableDepartments.vue?vue&type=template&id=0144a411&scoped=true"
import script from "./tabledepartments.view.js?vue&type=script&lang=js&external"
export * from "./tabledepartments.view.js?vue&type=script&lang=js&external"

import "./tabledepartments.css?vue&type=style&index=0&id=0144a411&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0144a411"]])

export default __exports__